module.exports = __webpack_public_path__ + "static/img/sv.1176ea28.svg";